import { getEnumNameSpaceName } from "@odata/GeneratedEnums.utils";
import { EntityTypeName } from "@odata/GeneratedEntityTypes";

export const VatRuleTranslationFiles = [
    "Vats",
    getEnumNameSpaceName(EntityTypeName.VatReverseCharge)
];